const hamburger = document.getElementById('hamburger');
const menu = document.getElementById('overlay');
const main = document.getElementsByTagName('main')[0];
let open = false;

const change = () => {
  let top = window.pageYOffset;
  let top2 = main.scrollTop;

  if (!open) {
    hamburger.classList.add('open');
    menu.classList.add('menu');
    document.body.style.overflow = 'hidden';
    main.classList.add('menu-open');

    setTimeout(function (e) {
      main.scrollTo({
        top: top
      });
    }, 25);
  } else {

    document.body.style.overflow = 'visible';
    main.classList.remove('menu-open');
    menu.classList.add('menu-pre-close');
    main.classList.add('pre-close');

    setTimeout(function (e) {
      window.scrollTo({
        top: top2
      });
    }, 25);
    setTimeout(function (e) {
      hamburger.classList.remove('open');
      menu.classList.remove('menu');
      main.classList.remove('pre-close');
      menu.classList.remove('menu-pre-close');
    }, 225);
  }
  open = !open;
};

hamburger.addEventListener('click', change);
